module.exports = __webpack_public_path__ + "static/linkedin-953f0d9d28601391b79e1303a4cbedd0.svg";